import React, { useEffect, useState } from 'react';
import { Button } from '@material-ui/core';
import { motion } from 'framer-motion';
import clsx from 'clsx';

import { getLatestAnnouncementId, setLatestAnnouncementId } from 'utils/localStorage';
import { trackAhoyEvent } from 'utils/ahoy';
import { getRequest } from 'utils/api';
import CloseIcon from 'public/icons/close-dark.svg';
import styles from 'styles/components/WhiteAlert.module.scss';

const buttonStyle = { height: 30, padding: '0 10px', marginTop: 15 };
const iconStyle = {
  position: 'absolute',
  right: 10,
  top: 5,
};

const AnnouncementAlert = ({}) => {
  const [alert, setAlert] = useState(null);

  useEffect(() => {
    getRequest({ endpoint: '/announcements/latest' }).then(alert => setAlert(alert));
  }, []);

  const handleDismiss = () => {
    setLatestAnnouncementId(alert.id);
    setAlert(null);
  };

  const handleClick = () => {
    trackAhoyEvent('Announcement Clicked', { id: alert.id });
    setLatestAnnouncementId(alert.id);
    setAlert(null);
  };

  const latestAlertId = getLatestAnnouncementId();

  if (!alert || alert.id === latestAlertId) return null;

  return (
    <motion.div
      className={clsx(styles.cardContainer, styles.announcementAlertCard)}
      style={{ marginTop: 20, background: 'rgba(18,223,199,0.18)' }}
      initial={{ x: -300, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
    >
      <CloseIcon onClick={handleDismiss} style={iconStyle} />

      <div className={styles.content} style={{ borderRadius: 15 }}>
        <h2 style={{ color: '#000' }}>{alert.title}</h2>
        <p style={{ color: '#000' }}>{alert.description}</p>

        {alert.url && (
          <a href={alert.url} target="_blank" rel="noopener noreferrer">
            <Button color="primary" variant="contained" style={buttonStyle} onClick={handleClick}>
              Check it out
            </Button>
          </a>
        )}
      </div>
    </motion.div>
  );
};

export default AnnouncementAlert;
